import { render, staticRenderFns } from "./PresRow.vue?vue&type=template&id=c8ea98ec&"
import script from "./PresRow.vue?vue&type=script&lang=js&"
export * from "./PresRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports